/* eslint-disable */
import $ from 'jquery';
import { getParamsFromURL } from '../util';
import { chatReasonOptions, S1_FULL_SITE_DECOMMISSION, TCSO, TCSO_DUAL_FUEL } from './Chat';

$(document).ready(() => {
  connect.ChatInterface.init({
    containerId: 'root',
    headerConfig: {
      isHTML: true,
      render: () => `
                <div class="connect-header" style="display: none;">
                  <h2 class="welcome-text">Metering Installation Support</h2>
                  <p id="chatDescription"></p>
                </div>
                `,
    },
  });
  $('#chatWrapper').hide();
});

function getChatReasonLevel(chatReason) {
  const DEFAULT_CHAT_REASON_LEVEL = '3';
  return chatReasonOptions.find((option) => option.value === chatReason)?.queue ?? DEFAULT_CHAT_REASON_LEVEL;
}

function isAutomatedJourney(chatReason) {
  switch (chatReason) {
    case 'Engineer comms checker':
    case 'Decommission a Meter':
    case S1_FULL_SITE_DECOMMISSION:
    case TCSO:
    case TCSO_DUAL_FUEL:
      return 'TRUE';
    default:
      return 'FALSE';
  }
}

export function startChat(initialChatMessage, sessionUserEmail, accessToken, mpxn, chatReason) {
  if (chatReason === 'Select issue') {
    return;
  }

  const userDomainArray = sessionUserEmail.split('@');
  const sessionUserName = userDomainArray[0];
  const sessionEmailDomain = userDomainArray[1];
  const chatReasonLevel = getChatReasonLevel(chatReason);

  if (!!sessionUserName && !!accessToken && !!sessionEmailDomain && !!chatReason) {
    const connectParams = getParamsFromURL();
    connectParams.customerName = sessionUserName;
    connectParams.emailDomain = sessionEmailDomain;
    connectParams.chatReason = chatReason;
    connectParams.chatReasonLevel = chatReasonLevel;
    connectParams.brand = 'OVO';
    connectParams.mpxn = mpxn || null;
    connectParams.isAutomatedJourney = isAutomatedJourney(chatReason);
    connectParams.initialChatMessage = initialChatMessage;

    $('.main-body-wrapper').fadeOut();
    $('.btn-container').fadeOut();
    $('#chatWrapper').show();
    const shadesEl = document.querySelector('.connect-customer-interface');
    shadesEl.classList.remove('sc-gipzik');
    shadesEl.classList.remove('eYCHsU');
    const username = 'UserName';
    connect.ChatInterface.initiateChat(
      {
        headers: {
          Authorizer: accessToken,
        },
        name: sessionUserName,
        username,
        region: process.env.REACT_APP_AWS_REGION,
        apiGatewayEndpoint: process.env.REACT_APP_AWS_LAMBDA_CHECK_ACTIVE_CHAT_URL,
        contactAttributes: JSON.stringify(connectParams),
      },
      successHandler,
      failureHandler,
    );
  }
}

function successHandler(chatSession) {
  $('#accessDeniedError').hide();
  $('#chatWrapper').show();
  window.chatSession = chatSession;

  connect.ChatSession.setGlobalConfig({
    loggerConfig: {
      logger: {
        error: (msg) => console.error(`Connect Chat Session message:|| ${msg}`),
      },

      level: connect.ChatSession.LogLevel.ERROR,
    },
    region: process.env.REACT_APP_AWS_REGION,
  });

  connect.WebSocketManager.setGlobalConfig({
    loggerConfig: {
      logger: {
        error: (msg) => console.error(`Connect Websocket Manager message:|| ${msg}`),
      },

      level: connect.WebSocketManager.LogLevel.ERROR,
    },
  });

  chatSession.incomingItemDecorator = (item) => {
    if (['SYSTEM_MESSAGE'].indexOf(item.displayName) !== -1) {
      item.displayName = 'MILES';
    }

    if (item.displayName === 'BOT') {
      item.displayName = 'MILES';
    }
    if (item.displayName === 'SYSTEM_MESSAGE') {
      item.displayName = 'MILES';
    }

    if (chatSession.transcript.length > 0) {
      // chat connected
      const transcriptItem = chatSession.transcript[chatSession.transcript.length - 1];
      if (transcriptItem.transportDetails.direction === 'Incoming') {
        let chatDescription = 'This is a demo of a customer chat experience.';
        const name = transcriptItem.displayName;
        if (['prod', '$LATEST', 'AI Assistant', 'SYSTEM_MESSAGE', 'System Message'].indexOf(name) === -1) {
          chatDescription = `You are now chatting with ${name}`;
        }
        document.getElementById('chatDescription').innerHTML = chatDescription;
      }
    }

    return item;
  };

  chatSession.onIncoming((data) => {
    console.log(`incoming message:|| ${JSON.stringify(data)}`);
    const myAudio = document.getElementById('my-audio');
    myAudio.play();
  });

  chatSession.onOutgoing((data) => {
    console.log(`outgoing message: ${JSON.stringify(data)}`);
  });

  chatSession.onChatDisconnected(() => {
    location.reload();
  });

  connect.ChatInterface.init({
    containerId: 'root',
    headerConfig: {
      isHTML: true,
      render: () => `
                <div class="connect-header" style="display: none;">
                  <h2 class="welcome-text">Metering Installation Support</h2>
                  <p id="chatDescription"></p>
                </div>
                `,
    },
  });
}

function failureHandler(error) {
  console.log(error);
  $('#chatWrapper').hide();
  setTimeout(() => {
    $('#accessDeniedError').hide();
    if (error.status === 401) {
      $('.main-body-wrapper').show();
      $('.btn-container').show();
    } else if (error._debug !== undefined) {
      // Access denied error case
      const errorConnectSuccess = error.connectSuccess;
      const errorAccessDenied = error._debug._debug.message;
      const errorReason = error._debug.reason;
      $('.main-body-wrapper').show();
      $('.btn-container').show();
      if (
        !errorConnectSuccess &&
        errorAccessDenied === 'Access denied' &&
        errorReason === 'Failed to fetch connectionDetails with createParticipantConnection'
      ) {
        $('#accessDeniedError').show();
        $('.main-body-wrapper').show();
        $('.btn-container').show();
      }
    } else {
      $('.main-body-wrapper').show();
      $('.btn-container').show();
    }
  }, 500);
}

export default function empty() {}
